import * as React from 'react'
import { Empty } from 'antd'
import type { Training } from 'shared/types'
import { useI18n } from 'context/I18nProvider'
import useFilters from 'hooks/filters'
import { useInfiniteSWR } from 'hooks/infinite-swr'
import Button from 'components/UI/Button'
import Section from 'components/UI/Section'
import { API_CATALOG_ACCREDITATIONS } from 'constants/api-v2'
import { messageContext } from 'utils/string'
import AccreditationFilters from './components/AccreditationFilters'
import TopSearch from '../components/TopSearch'
import FiltersWrapper from '../components/FiltersWrapper'
import Card from '../components/Card'

const PAGE_SIZE = 30

function Accreditation() {
  const filtersProps = useFilters('catalog-accreditation', true)
  const { values, setValue, url: urlFilters, reset } = filtersProps

  const { i18n, i18name } = useI18n()

  const { data, hasNext, next } = useInfiniteSWR(`${API_CATALOG_ACCREDITATIONS}?${urlFilters}`, true)

  const catalog = data || { nbResults: 0, results: [] }
  const empty = !catalog?.results?.length

  return (
    <div className="catalog relative flex flex-col">
      <div className="grid grid-cols-4 gap-6">
        <TopSearch
          // @TODO Port infinite-swr to TS */}
          // @ts-ignore */}
          total={catalog.nbResults}
          search={'q' in values && typeof values?.q === 'string' ? values.q : ''}
          onChange={(val: string) => setValue('q', val)}
          placeholder={i18n('catalog.accreditations.search.placeholder')}
          totalText={i18n('catalog.accreditations.available')}
        />
        <FiltersWrapper>
          <AccreditationFilters reset={() => reset()} values={values} setValue={setValue} />
        </FiltersWrapper>
        {!empty && catalog.results.map((item: Training) => (
          <Card
            key={item.id}
            training={item}
            path={<div>{`${i18name(item.accreditationDomain)}`}</div>}
          />
        ))}
        {empty && (
          <Section className="col-span-4"><Empty /></Section>
        )}
      </div>
      {!empty && hasNext && (
        <Button onClick={next} className="mt-8 self-center">
          {/* @TODO Port infinite-swr to TS */}
          {/* @ts-ignore */}
          {messageContext(i18n('label.infinite.scroll.button'), { nbPerPage: PAGE_SIZE })}
        </Button>
      )}
    </div>
  )
}

export default Accreditation
